export default __webpack_public_path__ + "static/media/norimmo.9bbcbecb.png";